'use client';

import { useFiltersContext } from '@components/FilterPage/Context/useFiltersContext';
import {
  Pagination,
  PaginationItem,
  PaginationItemRenderProps
} from '@coolblue-development/freddy';
import selectPageNumberTrigger from '@coolblue-development/ga4-events/triggers/Pagination/selectPageNumberTrigger';
import selectPreviousOrNextTrigger from '@coolblue-development/ga4-events/triggers/Pagination/selectPreviousOrNextTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { SearchResultsPagination } from '@server/careers-backend/search';
import React from 'react';

type Props = {
  pagination: SearchResultsPagination;
  activePage: number;
};

export const VacancyListPagination = ({ pagination, activePage }: Props) => {
  const paginationTranslations = useFreddyTranslations('pagination');
  const { updateActivePage } = useFiltersContext();
  const { trackEvent } = useAnalytics();

  const composePaginationItem = (item: PaginationItemRenderProps) => {
    return (
      <PaginationItem
        component='a'
        onClick={() => {
          if (item.type === 'page') {
            trackEvent(selectPageNumberTrigger({ index: item.page }));
          } else {
            trackEvent(
              selectPreviousOrNextTrigger({
                index: item.page,
                total_indices: pagination.pages,
                direction: item.type
              })
            );
          }
        }}
      >
        {item.label}
      </PaginationItem>
    );
  };
  return (
    <Pagination
      translations={paginationTranslations}
      activePage={activePage}
      totalPages={pagination.pages}
      onChange={updateActivePage}
      renderItem={composePaginationItem}
      aria-label='Pagination for vacancies'
    />
  );
};
